import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { checkmarkIcon } from '../../icons';

export interface IStep {
    type?: string;
    title?: string;
    subtitle?: string;
    locked?: boolean;
}

@Component({
    selector: 'app-stepper',
    template: `
        <ul class="stepper">
            <li
                class="stepper__step"
                (click)="index !== null && i < index && handleClick(step)"
                *ngFor="let step of steps; index as i"
                [class.stepper__step--touched]="index !== null && index > i"
                [class.stepper__step--active]="index !== null && index === i"
                [class.stepper__step--clickable]="index !== null && i < index && clickEnabled"
                [class.stepper__step--locked]="step.locked"
            >
                <div class="stepper__icon">${checkmarkIcon}</div>
                <div class="stepper__title">{{ step.title }}</div>
                <div *ngIf="step.subtitle" class="stepper__subtitle">
                    {{ step.subtitle }}
                </div>
            </li>
        </ul>
        <h6 class="stepper__counter">
            {{ 'checkout.step_navigation____mobile_step_count' | translate: { index: (index || 0) + 1, stepCount: steps.length } }}
        </h6>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
    @Input() steps: IStep[];
    @Input() index: number | null;
    @Input() clickEnabled?: boolean;
    @Output() stepClicked = new EventEmitter<IStep>();

    handleClick(step: IStep) {
        this.stepClicked.emit(step);
    }
}
